const ZoomLevels = [
  50, 70, 80, 90, 100, 110, 120, 130, 150, 170, 200, 300, 400,
].map((level) => level / 100);

const useZoom = ({
  scale,
  defaultScale,
  setScale,
}: {
  scale: number | undefined;
  defaultScale: number | null;
  setScale: (newScale: number) => void;
}) => {
  const increaseZoom = () => {
    if (!scale) return;
    const currentIndex = ZoomLevels.findIndex((level) => level >= scale);
    const nextIndex =
      currentIndex + 1 < ZoomLevels.length ? currentIndex + 1 : currentIndex;
    setScale(ZoomLevels[nextIndex]);
  };

  const decreaseZoom = () => {
    if (!scale) return;
    const currentIndex = ZoomLevels.findIndex((level) => level >= scale);
    const prevIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : 0;
    setScale(ZoomLevels[prevIndex]);
  };

  const zoomFitWidth = () => {
    if (!defaultScale) return;
    setScale(defaultScale);
  };

  return { increaseZoom, decreaseZoom, zoomFitWidth };
};

export default useZoom;
